import { Skeleton } from "@mantine/core";
import { useLoaderStore } from "./useLoader.hook";

interface AppSKeletonProps {
  children?: React.ReactNode;
  needLoading?: boolean;
  fullWidth?: boolean;
  radius?: "xs" | "sm" | "md" | "lg" | "xl" | "full";
  className?: string;
}

const AppSkeleton: React.FC<AppSKeletonProps> = ({
  children,
  needLoading = true,
  fullWidth = true,
  radius = "full",
  className,
}) => {
  const loaderStore = useLoaderStore();

  if (!needLoading) {
    return <>{children}</>;
  }

  const getRadius = (radius: string) => {
    switch (radius) {
      case "xs":
        return "after:rounded-xs";
      case "sm":
        return "after:rounded-sm";
      case "md":
        return "after:rounded-md";
      case "lg":
        return "after:rounded-lg";
      case "xl":
        return "after:rounded-xl";
      case "full":
        return "after:rounded-full";
      default:
        return "after:rounded-full";
    }
  };

  return (
    <Skeleton
      className={`h-max max-w-[min(100%,100vw)] before:bg-primary-default ${
        fullWidth ? "w-max" : ""
      } ${getRadius(radius)} ${className}`}
      component={"span"}
      visible={loaderStore.isLoadingBySkeleton()}
    >
      {children}
    </Skeleton>
  );
};

export default AppSkeleton;
